import React, { useEffect, useState } from 'react'
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Row, Col } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import Spinner from 'react-bootstrap/Spinner';
import * as apiUtility from "../../config/APIUtils";
import { Divider, IconButton, Paper, Tooltip, Box, Typography, Button } from "@mui/material";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import ErrorPopUp from '../Utility/ErrorPopUp';
import { RiFileExcel2Line } from "react-icons/ri";
import { BsFiletypePdf } from "react-icons/bs";
import { Sheet } from '@mui/joy';

function HomeDeficiencyReport(props) {

    const [hmStaffTemplateData, setHmStaffTemplateSumm] = useState([]);
    const [showSpinner, setshowSpinner] = useState(false);
    const toggleshowSpinner = () => setshowSpinner(!showSpinner);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [dataForErrorPopup, setDataForErrorPopup] = useState('');

    var homeId = props.homeId;
    var filterObj = props.filterBy;
    var staffFlag = props.staffFlag;
    var selectedRole = props.roleId;
    var crsPolicyType = props.crsPolicyType;
    // safe fetch function and effect (no async useEffect callback)
    const fetchHomeDeficiency = async () => {
        if (homeId === undefined || homeId === null) return;
        setshowSpinner(true);
        try {
            const body = {
                homeId: homeId,
                firstName: filterObj?.firstName || "",
                lastName: filterObj?.lastName || "",
                staffFlag: staffFlag,
                roleId: selectedRole,
                crsPolicyType: crsPolicyType
            };
            const apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "audit-report/home-missing-courses";
            apiRequest.data = body;
            const res = await apiUtility.sendAPIDataPOST(apiRequest);
            setHmStaffTemplateSumm(Array.isArray(res.data) ? res.data : []);
        } catch (error) {
            console.error("Error fetching home deficiency data:", error);
            setDataForErrorPopup("Unable to fetch data. Please try again.");
            setShowErrorPopup(true);
            setHmStaffTemplateSumm([]);
        } finally {
            setshowSpinner(false);
        }
    };

    useEffect(() => {
        let mounted = true;
        if (mounted) fetchHomeDeficiency();
        return () => { mounted = false; };
    }, [homeId, filterObj, staffFlag, selectedRole]);

    const headerStyleElement = {
        position: 'sticky',
        top: 0,
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #016594',
        zIndex: 1,

    }

    var orgStaffTemplateCols = [{
        dataField: 'user_id',
        sort: true,
        text: 'User ID',
        headerStyle: headerStyleElement
    },
    {
        dataField: 'first_name',
        sort: true,
        text: 'First Name',
        headerStyle: headerStyleElement
    }, {
        dataField: 'last_name',
        sort: true,
        text: 'Last Name',
        headerStyle: headerStyleElement
    }, {
        dataField: 'role_id',
        sort: true,
        text: 'Role ID',
        headerStyle: headerStyleElement
    },
    {
        dataField: 'role_name',
        sort: true,
        text: 'Role Name',
        headerStyle: headerStyleElement
    }, {
        dataField: 'role_status',
        sort: true,
        text: 'Role Status',
        headerStyle: headerStyleElement
    }, {
        dataField: 'missing_courses',
        text: 'Incomplete Course IDs',
        headerStyle: headerStyleElement
    }

    ];

    if (props.crsPolicyType == '11') {
        orgStaffTemplateCols.push({
            dataField: 'missing_policies',
            sort: true,
            text: 'Incomplete Home Doc Codes'
        });
    }
    if (props.crsPolicyType == '10') {
        orgStaffTemplateCols.splice(6, 1);
        orgStaffTemplateCols.push({
            dataField: 'missing_policies',
            sort: true,
            text: 'Incomplete Home Doc Codes'
        });
    }


    var exportHomeDefPDF = () => {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "portrait"; // portrait or landscape

        const marginLeft = 5;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        const title = "LCPT - Home Deficiency Report";

        var headers;
        var dataArr;


        dataArr = [];

        if (crsPolicyType == '9') {
            headers = [["User ID", "First Name", "Last Name", "Role ID", "Role Name", "Role Status", "Home ID", "Missing Courses"]];

            for (let i = 0; i < hmStaffTemplateData.length; i++) {
                let courseArr = (hmStaffTemplateData[i]["missing_courses"] !== null && hmStaffTemplateData[i]["missing_courses"] !== undefined) ? hmStaffTemplateData[i]["missing_courses"].replaceAll(",", ", ") : hmStaffTemplateData[i]["missing_courses"];
                var tempArr = [hmStaffTemplateData[i]["user_id"], hmStaffTemplateData[i]["first_name"], hmStaffTemplateData[i]["last_name"], hmStaffTemplateData[i]["role_id"],
                hmStaffTemplateData[i]["role_name"], hmStaffTemplateData[i]["role_status"], hmStaffTemplateData[i]["home_id"], courseArr];
                dataArr.push(tempArr);
            }
        }
        else if (crsPolicyType == '10') {
            headers = [["User ID", "First Name", "Last Name", "Role ID", "Role Name", "Role Status", "Home ID", "Missing Docs"]];

            for (let i = 0; i < hmStaffTemplateData.length; i++) {
                let courseArr = (hmStaffTemplateData[i]["missing_policies"] !== null && hmStaffTemplateData[i]["missing_policies"] !== undefined) ? hmStaffTemplateData[i]["missing_policies"].replaceAll(",", ", ") : hmStaffTemplateData[i]["missing_policies"];
                var tempArr = [hmStaffTemplateData[i]["user_id"], hmStaffTemplateData[i]["first_name"], hmStaffTemplateData[i]["last_name"], hmStaffTemplateData[i]["role_id"],
                hmStaffTemplateData[i]["role_name"], hmStaffTemplateData[i]["role_status"], hmStaffTemplateData[i]["home_id"], courseArr];
                dataArr.push(tempArr);
            }
        }
        else {
            headers = [["User ID", "First Name", "Last Name", "Role ID", "Role Name", "Role Status", "Home ID", "Missing Courses", "Missing Docs"]];

            for (let i = 0; i < hmStaffTemplateData.length; i++) {
                let courseArr = (hmStaffTemplateData[i]["missing_courses"] !== null && hmStaffTemplateData[i]["missing_courses"] !== undefined) ? hmStaffTemplateData[i]["missing_courses"].replaceAll(",", ", ") : hmStaffTemplateData[i]["missing_courses"];
                let policyArr = (hmStaffTemplateData[i]["missing_policies"] !== null && hmStaffTemplateData[i]["missing_policies"] !== undefined) ? hmStaffTemplateData[i]["missing_policies"].replaceAll(",", ", ") : hmStaffTemplateData[i]["missing_policies"];

                var tempArr = [hmStaffTemplateData[i]["user_id"], hmStaffTemplateData[i]["first_name"], hmStaffTemplateData[i]["last_name"], hmStaffTemplateData[i]["role_id"],
                hmStaffTemplateData[i]["role_name"], hmStaffTemplateData[i]["role_status"], hmStaffTemplateData[i]["home_id"], courseArr, policyArr];
                dataArr.push(tempArr);
            }
        }



        doc.setProperties({
            title: title,
            subject: 'Carepasport auto generated reports',
            author: 'LCPT',
            keywords: 'generated, javascript, web 2.0, ajax',
            creator: 'LCPT',
            bodyStyles: {
                color: '#cccccc'
            }
        });
        doc.text(title, 300, 40, {
            align: 'center'
        });
        let content = {
            startY: 50,
            head: headers,
            body: dataArr
        };


        autoTable(doc, content);
        let dateVar = new Date();
        let fileName = "Carepassport_HomeDeficiencyReport-" + dateVar.getDate() + dateVar.getMonth() + dateVar.getFullYear() + "_" + dateVar.getHours() + dateVar.getMinutes() + ".pdf";
        doc.save(fileName);
    }

    const workbook2blob = (workbook) => {
        const wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
        };
        const wbout = XLSX.write(workbook, wopts);
        const blob = new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        });
        return blob;
    };
    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i++) {
            view[i] = s.charCodeAt(i);
        }
        return buf;
    }

    //Excel
    const exportInExcel = async () => {
        try {
            var rowsCount = 6;
            const title = [{ A: 'CarePassport - Deficiency Report for Home ID : ' + String(homeId) }];
            let reportView = [{ A: 'Name', B: 'User ID', C: 'Role', D: 'Date' }];
            reportView.push({
                A: sessionStorage.getItem('fullName'),
                B: sessionStorage.getItem('userId'),
                C: (sessionStorage.getItem('userType') !== null) ? sessionStorage.getItem('userType').toUpperCase() : "User",
                D: new Date().toLocaleString()
            });
            reportView.push("");
            reportView.push("");
            var reportHeaders;
            if (crsPolicyType == '9') {
                reportHeaders = { A: 'User ID', B: 'Role ID', C: 'Role Name', D: 'First Name', E: 'Last Name', F: 'Role Status', G: 'Incomplete Course IDs' };
                reportView.push(reportHeaders);
                // orgStaffTemplateData.forEach(element => {
                hmStaffTemplateData.forEach(element => {
                    rowsCount += 1;
                    var tempObj = {
                        A: element.user_id,
                        B: element.role_id,
                        C: element.role_name,
                        D: element.first_name,
                        E: element.last_name,
                        F: element.role_status,
                        G: element.missing_courses
                    };
                    reportView.push(tempObj);
                });
            }
            else if (crsPolicyType == '10') {
                reportHeaders = { A: 'User ID', B: 'Role ID', C: 'Role Name', D: 'First Name', E: 'Last Name', F: 'Role Status', G: 'Incomplete Home Doc Codes' };
                reportView.push(reportHeaders);
                // orgStaffTemplateData.forEach(element => {
                hmStaffTemplateData.forEach(element => {
                    rowsCount += 1;
                    var tempObj = {
                        A: element.user_id,
                        B: element.role_id,
                        C: element.role_name,
                        D: element.first_name,
                        E: element.last_name,
                        F: element.role_status,
                        G: element.missing_policies
                    };
                    reportView.push(tempObj);
                });
            }
            else {

                reportHeaders = { A: 'User ID', B: 'Role ID', C: 'Role Name', D: 'First Name', E: 'Last Name', F: 'Role Status', G: 'Incomplete Course IDs', I: 'Incomplete Home Doc Codes' };
                reportView.push(reportHeaders);
                // orgStaffTemplateData.forEach(element => {
                hmStaffTemplateData.forEach(element => {
                    rowsCount += 1;
                    var tempObj = {
                        A: element.user_id,
                        B: element.role_id,
                        C: element.role_name,
                        D: element.first_name,
                        E: element.last_name,
                        F: element.role_status,
                        G: element.missing_courses,
                        I: element.missing_policies
                    };
                    reportView.push(tempObj);
                });

            }

            const finalData = [...title, ...reportView];
            const worksheet = XLSX.utils.json_to_sheet(finalData, {
                skipHeader: true,
            });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Home Deficiency Report");
            const workbookblob = workbook2blob(workbook);
            var headerIndexes = [];
            finalData.forEach((data, index) =>
                data["A"] === "User ID" ? headerIndexes.push(index) : null
            );
            const dataInfo = {
                titleCell: "A2",
                titleRange: crsPolicyType == "11" ? "A1:H1" : "A1:G1",
                tbodyRange: `A7:G${finalData.length}`,
                uHeadRange: `A2:D2`,
                uBodyRange: `A3:D3`,
                theadRange:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[0] + 1}:G${headerIndexes[0] + 1}`
                        : null,
                theadRange1:
                    headerIndexes?.length >= 2
                        ? `A${headerIndexes[1] + 1}:I${headerIndexes[1] + 1}`
                        : null,
                tFirstColumnRange:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[0] + 1}:A${rowsCount + headerIndexes[0] + 1}`
                        : null,
                tLastColumnRange:
                    headerIndexes?.length >= 1
                        ? `K${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[0] + 1}`
                        : null,

                tFirstColumnRange1:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[1] + 1}:A${rowsCount + headerIndexes[1] + 1}`
                        : null,
                tLastColumnRange1:
                    headerIndexes?.length >= 1
                        ? `H${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[1] + 1}`
                        : null,
            };
            XlsxPopulate.fromDataAsync(workbookblob).then((workbook) => {
                workbook.sheets().forEach((sheet) => {
                    sheet.column("A").width(15);
                    sheet.column("B").width(15);
                    sheet.column("C").width(30);
                    sheet.column("D").width(30);
                    sheet.column("E").width(30);
                    sheet.column("F").width(20);
                    sheet.column("G").width(40);
                    if (crsPolicyType == '11') {
                        sheet.column("H").width(40);
                    }
                    sheet.range(dataInfo.titleRange).merged(true).style({
                        bold: true,
                        fontFamily: "Arial",
                        horizontalAlignment: "center",
                        verticalAlignment: "center",
                    });
                    sheet.range(dataInfo.uHeadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    sheet.range(dataInfo.uBodyRange).style({
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tbodyRange) {
                        sheet.range(dataInfo.tbodyRange).style({
                            horizontalAlignment: "left",
                        });
                    }
                    sheet.range(dataInfo.theadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tFirstColumnRange) {
                        sheet.range(dataInfo.tFirstColumnRange).style({
                            bold: true,
                        });
                    }

                });

                return workbook.outputAsync().then((workbookBlob) => {
                    const downloadAnchorNode = document.createElement("a");
                    var dateVar = new Date();
                    var fileName = "Carepassport_HomeDeficiencyReport-" + dateVar.getDate() + dateVar.getMonth() + dateVar.getFullYear() + "_" + dateVar.getHours() + dateVar.getMinutes() + ".xlsx";
                    downloadAnchorNode.setAttribute("href", URL.createObjectURL(workbookBlob));
                    downloadAnchorNode.setAttribute("download", fileName);
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();
                    // setDataForSuccessPopup("Downloaded Successfully");
                    // setShowSuccessPopup(true);
                });
            });
        } catch (error) {
            setDataForErrorPopup("Something went wrong while processing excel!");
            setShowErrorPopup(true);
        }
    }

    const NoRowsOverlay = () => {
        return (
            <div className="text-center p-4">
                No records found for the selected date range.
            </div>
        );
    };

    const TABLE_CONTAINER_STYLE = {
        height: '700px',
        overflowY: 'auto',
        position: 'relative'
    };

    return (
        <Box sx={{ position: 'relative', width: '100%' }}>
            {showSpinner && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0, left: 0, right: 0, zIndex: 10, py: 2 }}>
                    <Spinner animation="border" size="lg" variant='primary' />
                </Box>
            )}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                <Paper component="form" variant="outlined"
                    sx={{ float: "right", display: 'flex', marginBottom: "4px", alignItems: 'center', width: 100 }}
                >
                    <Tooltip variant="contained" title="Export to PDF" disableRipple>
                        <IconButton color="primary" onClick={exportHomeDefPDF} sx={{ p: '10px' }} aria-label="directions">
                            <BsFiletypePdf />
                        </IconButton>
                    </Tooltip>
                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    <Tooltip variant="contained" title="Export to Excel" disableRipple>
                        <IconButton color="primary" onClick={exportInExcel} sx={{ p: '10px' }} aria-label="directions">
                            <RiFileExcel2Line />
                        </IconButton>
                    </Tooltip>
                </Paper>
            </Box>
            <Sheet variant="outlined" sx={{ borderRadius: "md" }} style={TABLE_CONTAINER_STYLE}>
                <BootstrapTable id='organizationStaffTemplateTable' noDataIndication={NoRowsOverlay} keyField='id' data={hmStaffTemplateData} columns={orgStaffTemplateCols} striped hover />
            </Sheet>
            <ErrorPopUp show={showErrorPopup} data={dataForErrorPopup} onHide={() => { setShowErrorPopup(false) }} />
        </Box>

    );
}

export default HomeDeficiencyReport